import moment from 'moment'

export function isBetween(today,start,end) {
  if(start==end) return false
  else if(moment(start).isBefore(end)) return moment(today).isBetween(start, end)
  // else return moment(today).isBetween(start, moment(end).add(1, 'y')) || moment(today).isBetween(moment(start).subtract(1, 'y'), end)
  else return moment(today).isBefore(end) || moment(start).subtract(1, 'd').isBefore(today)//不同年份，如2023-06-01～2024-04-01
}
export function isBetween2(today, start, end) {
    //包含start和end那一天
    return moment(today).isBetween(
    //   moment(start).subtract(1, "d"),
      moment(start),
      moment(end).add(1, "d")
    );
  }
/* 时间过滤器 - 日/月/年 */
export function formatDate(value) {
  return value ? moment(value).format('DD/MM/yyyy') : ''
}

export function formatDate2(value) {
  return value ? moment(value).format('YYYY-MM-DD') : ''
}

export function formatDateTime(value) {
  // return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
  return value ? moment(value).format('DD/MM/yyyy HH:mm') : ''
}

export function formatDateTime2(value) {
  // return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
  return value ? moment(value).format('DD/MM/yyyy hh:mm a') : ''
}

export function formatTime(value) {
  return value ? moment(value).format('HH:mm:ss') : ''
}

export function progress(value){
  return  value ==0 ? 'Not Started Yet' : value + '%';
}

///html标签替换
export function richText(value){
  return  value !==''? value.replace(/<.+?>/g, ''): '';
}

///判断输入值是否为正整数
export function isPositiveInteger(s){
  
  if((/(^[1-9]\d*$)/.test(s))) {
     return `+${s}`
  } else {
    return s
  }
  
}   

//// 全字母大写
export function toUpperCase(value) {
   return   value.slice(0,1).toUpperCase() +value.slice(1).toLowerCase(); 
}
//// 全字母大写
export function replace(value) {
   return value !==''? value.replace(/zh/g,''): ''
}

///设置绝对值

export function abs(value){
   return Math.abs(value); 
}

export function ellipsis(value){
  if (!value) return '';
  if (value.length > 100) {
    return value.slice(0,100) + '...'
  }
  return value
}

export function toFixed(value){
  return value.toFixed(1)
}
export function numFilter (val) {
  val = Math.round(val * 10) / 10
  var xsd = val.toString().split('.')
  if (xsd.length === 1) {
    val = val.toString() + '.0'
    return val
  }
  return val
}
